import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Login from "../../components/Login";
import Registration from "../../components/Registration";
import RemindPass from "../../components/RemindPass";

interface IProps {
  rootClass: any;
  textClass: any;
}

const LoginButton: React.FC<IProps> = ({ rootClass, textClass }: IProps) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showRemindPass, setShowRemindPass] = useState(false);
  return (
    <React.Fragment>
      <Link onClick={() => setShowLogin(true)} component={"li"} style={{ textDecoration: "none" }}>
        <ListItem button classes={{ root: rootClass }}>
          <ListItemText classes={{ primary: textClass }} primary={"Zaloguj"} />
        </ListItem>
        <Divider />
      </Link>

      <Login
        open={showLogin}
        onClose={() => setShowLogin(false)}
        onRegister={() => setShowRegister(true)}
        onRemindPass={() => setShowRemindPass(true)}
      />
      <Registration open={showRegister} onClose={() => setShowRegister(false)} />
      <RemindPass open={showRemindPass} onClose={() => setShowRemindPass(false)} />
    </React.Fragment>
  );
};

export default LoginButton;
